<template>
  <div class="top_navigation">
    <div
      style="display: flex; justify-content: space-between; line-height: 60px"
    >
      <div style="cursor: pointer">
        <img
          @click="$router.push('/')"
          alt="Cpms logo"
          src="../assets/cpms_logo.png"
          width="160"
        />
      </div>


      <!-- <div style="font-size: 18px;
    color: blueviolet;
    font-weight: bold;">
        Mise à jour des données en cours ...
      </div> -->

      <div style="display: flex; line-height: 60px">
        <div v-if="mainInfo.cotiNoPay" style="margin-right: 20px;">
          <a-button
            type="primary"
            size="small"
            shape="round"
            ghost
            danger
            @click="$router.push('/portefeuille/at')"
          >
            Cotisations impayées
          </a-button>
        </div>

        <div>
          <a-button
            type="primary"
            size="small"
            shape="round"
            ghost
            @click="$router.push('/news')"
          >
            Notifications
            <!-- <span style="color: red" v-if="!mainInfo.messagesIsSeen">1</span> -->
          </a-button>
        </div>
        <div>
          <div v-if="isGr" style="margin-left: 20px;">
            <a-button
              type="ghost"
              shape="round"
              size="small"
              @click="$router.push('/courtiers')"
            >
              Sélectionner courtier
            </a-button>
          </div>
        </div>
        <div style="width: 130px; margin-left: 48px; margin-right: 30px">
          <a-popover placement="bottomRight">
            <template #content>
              <div
                style="
                  padding-bottom: 12px;
                  margin-bottom: 12px;
                  border-bottom: 1px solid #f1f1f1;
                "
              >
                <a-button
                  @click="$router.push('/profil')"
                  type="ghost"
                  shape="round"
                >
                  Profil
                </a-button>
              </div>

              <div>
                <a-button @click="logout()" type="ghost" shape="round">
                  Déconnexion
                </a-button>
              </div>
            </template>

            <div style="cursor: pointer">
              <img :src="$icons.profile" width="32" />

              <div
                style="
                  display: inline-block;
                  margin-left: 12px;
                  vertical-align: top;
                  font-size: 16px;
                "
              >
                Mon profil
              </div>
            </div>
          </a-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopMenu",
  methods: {
    logout() {
      this.$axios.post("/auth/logout").then((r) => {
        if (r.status === 200) {
          localStorage.clear();
          window.location.href = "/";
        }
      });
    },
    showPrMenu(open) {
      var m = document.getElementById("profil");
      if (open) {
        m.style.display = "block";
      } else {
        m.style.display = "none";
      }
    },
  },
  computed: {
    isGr() {
      return this.$store.getters.grBrokers.length == 0 ? false : true;
    },
    cabinet() {
      return this.$store.getters.cabinet;
    },
    mainInfo() {
      return this.$store.state.mainInfo;
    },
    noCoti() {
      if (parseInt(this.mainInfo.cotiNoPaySante) > 0) return true;
      if (parseInt(this.mainInfo.cotiNoPayPrev) > 0) return true;
      if (parseInt(this.mainInfo.cotiNoPayAutre) > 0) return true;
      return false;
    },
  },
};
</script>

<style>
.top_navigation {
  background-color: #fff;
  -webkit-box-shadow: 0 0 3px #a4b1bf;
  box-shadow: 0 0 3px #a4b1bf;
  height: 60px;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  z-index: 3;
  min-width: 836px;
}
</style>
